import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { yellow } from '../../../styles/mui/colors';
import { hasCurrentUserValidAnnualPass } from '../../../util/annualPass';
import useAppSelector from '../../../util/hooks/useAppSelector';
import BoxSeparator from '../../BoxSeperator/BoxSeparator';
import Link from '../../Links/Link/Link';

const annualPassButtonStyle = {
  textDecoration: 'none',
  justifyContent: 'space-between',
  '&:hover': {
    bgcolor: yellow.main,
  },
};

const SectionAnnualPassAdComponent = ({ onClose }) => {
  const currentUser = useAppSelector((state) => state.user.currentUser);
  const annualPassIsValid = hasCurrentUserValidAnnualPass(currentUser);

  return !annualPassIsValid ? (
    <>
      <BoxSeparator />
      <Stack px={4} spacing={2} width="100%">
        <Button
          color="primary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={annualPassButtonStyle}
          to={{
            name: 'StoryblokPage',
            params: {
              slug: 'pass',
            },
          }}
          variant="outlined"
        >
          <Stack textAlign="start">
            <Typography gutterBottom variant="h4">
              <FormattedMessage id="AccountBottomBarBox.annualPass" />
            </Typography>
            <Typography variant="body1">
              <FormattedMessage id="AccountBottomBarBox.annualPassSubHeading" />
            </Typography>
          </Stack>
          <ChevronRightIcon color="secondary" />
        </Button>
      </Stack>
    </>
  ) : null;
};

SectionAnnualPassAdComponent.displayName = 'SectionAnnualPassAd';
const SectionAnnualPassAd = memo(SectionAnnualPassAdComponent);

export default SectionAnnualPassAd;
